import styled from "styled-components"


export const  Container = styled.div`
padding: 10px 10px;
margin-top:20px;
background: radial-gradient(circle, rgba(11,66,65,255)0%, rgba(11,66,65,255)100%)
`

export const  Wrapper = styled.div`
display:flex;
flex-direction: column;
justify-content: center;
max-width: 1100px;
margin: 0 auto;
`

export const  Column = styled.div`
display: flex;
flex-direction: column;
text-align: left;
 
`
export const  Bottom = styled.div`
color: #fff;
 
`

export const  Row = styled.div`
display: grid;
grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
grid-gap: 12px;
border-color: 1px solid #fff

@media screen and (max-width: 1000px){
    grid-template-column: repeat(auto-fill, minmax(200px, 1fr));
}
`

export const  Link = styled.a`
color: #fff;
margin-bottom: 10px;
font-size: 18px;
text-decoration: none;

&:hover{
    color: #ff9c00;
    transition: 200ms ease-in;
}
`

export const  Title = styled.p`
font-size: 24px;
color: #fff;
margin-bottom: 40px;
font-weight:bold;
`
 
